<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "app",
    data: function () {
      return {};
    },
    created() {
      this.$store.dispatch("getAccess");
    },
  };
</script>

<style lang="scss">
  html,
  body,
  ul,
  i,
  li,
  a,
  p,
  nav,
  header,
  h1,
  h2,
  div,
  figure {
    padding: 0px;
    margin: 0px;
  }
  ul,
  li {
    list-style: none;
  }
  body {
    width: 100%;
    font-family: "微软雅黑", "Microsoft YaHei", "PingFang SC";
  }
  a {
    text-decoration: none;
  }
  a:any-link {
    color: #ffffff;
  }
  a:-webkit-any-link {
    color: #ffffff;
  }
  input,
  button {
    -webkit-appearance: none;
  }
  input,
  button:focus {
    outline: none;
  }
  .el-breadcrumb {
    padding-top: 20px;
  }
  .el-table__body {
    // 使表格兼容safari，不错位
    width: 100%;
    table-layout: fixed !important;
  }
  .el-textarea .el-textarea__inner {
    resize: none;
  }
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #808080 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue